const PREFIX = '[GUEST_PICKER_VALIDATION]';

export const GUEST_PICKER_VALIDATION_TRIGGER = `${PREFIX} GUEST_PICKER_VALIDATION_TRIGGER`;
export const GUEST_PICKER_VALIDATION_RESET = `${PREFIX} GUEST_PICKER_VALIDATION_RESET`;

export const guestPickerValidationTrigger = () => ({
  type: GUEST_PICKER_VALIDATION_TRIGGER,
});

export const guestPickerValidationReset = () => ({
  type: GUEST_PICKER_VALIDATION_RESET,
});
